import { FoundVacancies } from "@/model/find-vacancies-response";
import { Api } from "@/utils/api";
import Vacancy from "@/model/vacancy";

export class VacancyCollection {
	private static instance: VacancyCollection;
	private vacancies: Map<string, Vacancy> = new Map();

	private constructor(private api: Api) {
	}

	static getInstance(): VacancyCollection {
		if (VacancyCollection.instance == null) {
			VacancyCollection.instance = new VacancyCollection(Api.getInstance());
		}
		return VacancyCollection.instance;
	}

	/**
	 * Method which retrieves vacancies based on a set of parameters (filters) from the vacancies API endpoint.
	 */
	findVacancies(searchParams: URLSearchParams): Promise<FoundVacancies> {

		return this.api.findVacancies(searchParams)
			.then((response: any) => {
				this.vacancies = response.vacancies
					.map((data: any) => new Vacancy(data));
				return Promise.resolve(new FoundVacancies(response));
			});
	}
}